<template>
  <div class="UserInfo flex items-center truncate">
    <lm-avatar
      :src="avatarSource"
      alt="User avatar"
      :size="cSize"
      class="flex-shrink-0"
      :class="compacted ? 'mr-2' : 'mr-3'"
    />
    <div class="flex truncate" :class="compacted ? '' : 'flex-col'">
      <h1 class="text-gray-700 font-sans truncate">{{ username }}</h1>
      <span v-if="compacted" class="Separator ml-5px mr-1 text-gray-500" />
      <span
        v-if="hasSlot"
        class="text-gray-500 font-sans truncate"
        :class="compacted ? 'text-xs' : 'mt-1 ml-px text-s'"
        ><slot
      /></span>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import LmAvatar from '@/components/ui/LmAvatar'
const UNKOWN_USERNAME = 'Unknown user'
export default {
  name: 'UserInfo',
  components: {LmAvatar},
  props: {
    // user or id required
    user: {
      type: Object,
      required: false,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: '40px'
    },
    compacted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getUserByID']),
    hasSlot() {
      return !!this.$slots.default
    },
    _user() {
      return this.user ? this.user : this.getUserByID(this.id)
    },
    avatarSource() {
      return this._user ? this._user.picture : undefined
    },
    username() {
      return this.label
        ? this.label
        : this._user
        ? this._user.username || UNKOWN_USERNAME
        : UNKOWN_USERNAME
    },
    cSize() {
      return this.compacted ? '24px' : this.size
    }
  }
}
</script>

<style scoped>
.Separator:before {
  content: '\00B7';
}
</style>
